.preparedSpellsBadge {
  --color-bg: var(--color-accent);

  font-family: sans-serif;
  background: transparent;
  border-radius: 20px;
  color: #fff;
  font-size: 14px;
  font-weight: normal;
  padding: 0;
  height: 28px;
  width: auto;
  overflow: hidden;
  display: flex;
  align-items: stretch;

  &.warning {
    --color-bg: var(--color-warning);
  }

  &:hover {
    filter: brightness(1.1);
    background: transparent;
  }

  .badgeSegment {
    background: var(--color-bg);
    display: flex;
    align-items: center;
    padding: 4px 12px;
    gap: 12px;
    max-width: 200px;
    transition-timing-function: ease-in;
    transition-property: color, max-width, padding, margin;
    transition-duration: 300ms;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &:not(:last-child) {
      margin-right: 1px;
    }

    &:last-child:first-child:has(svg) {
      padding-right: 16px;
    }

    > svg {
      margin: 0 -8px;
      display: inline-block;
      fill: #fff;
      height: 20px;
      width: 20px;
    }
  }

  &:not(.open) {
    .badgeSegment:not(:first-child, :last-child) {
      transition-timing-function: ease-out;
      color: transparent;
      max-width: 0;
      padding: 0;
      margin: 0;
    }
  }

  .seeMore path {
    transition: d 300ms;
  }

  &.open .seeMore path {
    d: path("M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z");
  }
}
